import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectLoading, selectSaved, selectSaving, selectError, selectLicense } from '../selectors/license.selector';
import { licenseActions } from '../actions/license.actions';
import { LicenseValue, UpgradeLicenseValue } from '../models';

@Injectable({
    providedIn: 'root',
})
export class LicenseFacade {
    private store = inject(Store);

    readonly license = this.store.selectSignal(selectLicense);
    readonly loading = this.store.selectSignal(selectLoading);
    readonly saving = this.store.selectSignal(selectSaving);
    readonly saved = this.store.selectSignal(selectSaved);
    readonly error = this.store.selectSignal(selectError);

    getLicense(id: string): void {
        this.store.dispatch(licenseActions.getLicense({ id }));
    }

    updateLicense(id: string, value: LicenseValue): void {
        this.store.dispatch(licenseActions.updateLicense({ id, value }));
    }

    upgradeLicense(id: string, value: UpgradeLicenseValue): void {
        this.store.dispatch(licenseActions.upgradeLicense({ id, value }));
    }

    clear(): void {
        this.store.dispatch(licenseActions.clear());
    }
}
